// Dev-only diagnostics; silent in production builds.
export const warn = (...args) => {
  if (process.env.NODE_ENV === "development") console.warn(...args);
};
